import { DocMimeType, DocType } from './index';

export class DmsDocumentRqst {
  referenceNumber: string;
  docType: DocType;
  mimeType: DocMimeType;
}
